import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/vigilancia/minuta";

export const VigilanteMinutaService = {
  getMinutas: (params = {}) =>
    axiosInstance.get(BASE_URL + "/", { params }),

  getMinutaBySlug: (slug) =>
    axiosInstance.get(`${BASE_URL}/${slug}/`),

  createMinuta: (data) =>
    axiosInstance.post(BASE_URL + "/", data),

  updateMinuta: (slug, data) =>
    axiosInstance.patch(`${BASE_URL}/${slug}/`, data),

  deleteMinuta: (slug) =>
    axiosInstance.delete(`${BASE_URL}/${slug}/`),

  getComentarios: (params = {}) =>
    axiosInstance.get("/api/v3/vigilancia/minuta-comentarios/", { params }),

  createComentario: (data) =>
    axiosInstance.post("/api/v3/vigilancia/minuta-comentarios/", data),

  getDropdownPrioridad: () =>
    axiosInstance.get("/api/v3/vigilancia/minuta/dropdown_prioridad/"),
};

export const PRIORIDAD_COLORS = {
  red: 'rgba(255, 0, 0, 0.35)',
  yellow: 'rgba(255, 223, 0, 0.4)',
  light_green: 'rgba(144, 238, 144, 0.4)',
  white: 'rgba(255, 255, 255, 0.3)',
};

export default VigilanteMinutaService;